import React, { Component } from "react";
import "./LandingFooter.scss";
import logo from "../../assets/logo.svg";
import { Link, NavLink, withRouter } from "react-router-dom";
import {
  FaSearch,
  FaBell,
  FaAngleDown,
  FaUserCircle,
  FaUserPlus,
  FaPhoneAlt,
  FaUser,
  FaYoutube,
  FaInstagram,
  FaFacebookSquare,
  FaTwitter,
} from "react-icons/fa";

class LandingFooter extends Component {
  state = {

  };


  render() {

    return (
      <footer className="landing-footer-wrapper">
        <div className="container">
          <div className="landing-footer-content">
            <div className="footer-card-holder">
              <img src={logo} alt="" />
              <p> الأصول العربية العقارية توفر لك خدمة توحيد الأقساط بضمان العقار و التي ستمكنك من دمج قروضك كقرض واحد لجهة واحدة</p>
              <a href="tel:+920020310" className="tel-holder">
                <FaPhoneAlt />
                <p>للاستفسار</p>
                920020310
              </a>
              <div className="social-holder">
                <a href="" target="_blank">
                  <FaInstagram />
                </a>
                <a href="" target="_blank">
                  <FaYoutube />
                </a>
                <a href="" target="_blank">
                  <FaFacebookSquare />
                </a>
                <a href="" target="_blank">
                  <FaTwitter />
                </a>
              </div>
              <div className="copy-p">
              جميع الحقوق محفوظة، شركة الأصول العربية العقارية © 2021
              </div>
            </div>
            <div className="footer-card-holder">
              <h4>تواصل معنا</h4>
              <ul>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%aa%d9%88%d8%a7%d8%b5%d9%84-%d9%85%d8%b9%d9%86%d8%a7/">اتصل بنا</a></li>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%aa%d9%88%d8%a7%d8%b5%d9%84-%d9%85%d8%b9%d9%86%d8%a7/#">رفع شكوى</a></li>
              </ul>
            </div>
            <div className="footer-card-holder">
              <h4>روابط </h4>
              <ul>
                <li><a href="https://vga.f4a.myftpupload.com/#">وظائف</a></li>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%ae%d8%af%d9%85%d8%a7%d8%aa%d9%86%d8%a7/">الخدمات</a></li>
                <li><Link to="calculate-finance">احسب تمويلك</Link></li>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%a7%d9%84%d8%a7%d8%b3%d8%a6%d9%84%d9%87-%d8%a7%d9%84%d8%b4%d8%a7%d8%a6%d8%b9%d9%87/">الاسئله الشائعه</a></li>
              </ul>
            </div>
            <div className="footer-card-holder">
              <h4>الاستخدام  </h4>
              <ul>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%a7%d9%84%d8%b4%d8%b1%d9%88%d8%b7-%d9%88%d8%a7%d9%84%d8%a3%d8%ad%d9%83%d8%a7%d9%85/">الشروط والأحكام</a></li>
                <li><a href="https://vga.f4a.myftpupload.com/%d8%b3%d9%8a%d8%a7%d8%b3%d8%a9-%d8%a7%d9%84%d8%ae%d8%b5%d9%88%d8%b5%d9%8a%d8%a9/"></a>سياسيه الخصوصية</li>
              </ul>
            </div>
            <div className="footer-card-holder">
              <h5>اعتماد الشركة من الهيئة العامة للعقار</h5>
              <div className="footer-card-paper-num">
                <p>رقم الشهاده</p>
                <p>920020310</p>
              </div>
              <h5>ساعات العمل</h5>
              <div className="footer-card-time-num">
                <p>09AM - 10PM</p>
                <p>يوميا</p>
              </div>
            </div>
          </div>
        </div>
      </footer>      
    );
  }
}

export default LandingFooter;
